import { toast } from "react-toastify";
import { PublishedMemo, MemoDetailResult, MemoSendResult, MemosResult } from "models/memo";

const getJson = async (url: string) => {
    const res = await fetch(url, { credentials: 'include', method: 'GET' });
    const data = await res.json();
    if (!res.ok) throw new Error(data.message);
    return data.data;
}

/** Admin > System Updates Memo: every note with its send history. */
export const getMemos = async (): Promise<MemosResult | null> => {
    try {
        return await getJson(`${process.env.REACT_APP_API_URL}/memos`) as MemosResult;
    } catch (err: any) {
        toast.error(err.message ?? "Error getting the memos");
        return null;
    }
}

export const getMemo = async (slug: string): Promise<MemoDetailResult | null> => {
    try {
        return await getJson(`${process.env.REACT_APP_API_URL}/memos/${encodeURIComponent(slug)}`) as MemoDetailResult;
    } catch (err: any) {
        toast.error(err.message ?? "Error getting the memo");
        return null;
    }
}

/** test = only to me; otherwise every active employee. force = send again after a previous send to everyone. */
export const sendMemo = async (slug: string, options: { test?: boolean, force?: boolean }): Promise<MemoSendResult | null> => {
    try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/memos/${encodeURIComponent(slug)}/send`, {
            credentials: 'include',
            method: 'POST',
            body: JSON.stringify(options),
            headers: { 'Content-Type': 'application/json' },
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.message);

        const result = data.data as MemoSendResult;
        toast.success(options.test
            ? "Test email sent to you."
            : `Memo sent to ${result.recipientCount} people.`);
        return result;
    } catch (err: any) {
        toast.error(err.message ?? "Error sending the memo");
        return null;
    }
}

/** Version Log: notes already sent to everyone, newest first. */
export const getPublishedMemos = async (): Promise<PublishedMemo[] | null> => {
    try {
        return await getJson(`${process.env.REACT_APP_API_URL}/memos/published`) as PublishedMemo[];
    } catch (err: any) {
        toast.error(err.message ?? "Error getting the version log");
        return null;
    }
}
